import { getEnumObject } from '../utilities.js';
export const cpPayoutStatuses = {
  FAILED: 3,
  PAYOUT_INITIATED: 1,
  SETTLED: 2,
};

export default getEnumObject(cpPayoutStatuses);
